import './assets/stylus/main.styl'
import Vue from 'vue'
import App from './App.vue'
import {
  setupRouter
} from './router'
import store from './store'
import i18n, {
  initI18N
} from './plugins/i18n'
import vuetify from './plugins/vuetify'
import Dialog from './plugins/dialog'
import Snackbar from './plugins/snackbar'

import Config from './utils/config'
import '@/components/core'

Vue.config.productionTip = false

const router = setupRouter(store)

Config.init(store)
initI18N(router, Vue.prototype.$http)

Vue.use(Snackbar, {
  vuetify
})
Vue.use(Dialog, {
  vuetify
})

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: h => h(App)
}).$mount('#app')
